/**
 * Filter option value translations (canonical values from DB).
 */
export default {
  'Продажа': 'Sale',
  'Аренда': 'Rent',
  'Аренда долгосрочная': 'Long-term rent',
  'Обмен': 'Exchange',
  'Квартиры': 'Apartments',
  'Дома': 'Houses',
  'Земля': 'Land',
  'Гаражи / стоянки': 'Garages / parking',
  'Коммерческие помещения': 'Commercial',
  'От застройщика': 'From developer',
}
